import React, { useEffect,useRef } from "react"; // Removed useState, useEffect
import classes from './PaymentVoucher.module.css';
import {useState} from "react"
import { useLocation, useNavigate } from "react-router-dom";
import rccgLogo from "../../../../Assets/rccglogo.png"
import ExcelLogo from "../../../../Assets/excel.png"
import PdfLogo from "../../../../Assets/pdf.png"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// All API (axios, BASE_URL) and context (useUser) imports are removed.

import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings
} from 'lucide-react';

const PaymentVoucher = () => {
    const printRef = useRef();
    const [province,setProvinve] = useState("");
    const [userName,setUserName] = useState("");
    const [provinceEmail,setProvinceEmail] = useState("");
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const getProvince = localStorage.getItem("province");
        const getEmail = localStorage.getItem("userEmail");
        const getUserName = localStorage.getItem("tobi");
setProvinceEmail(getEmail);
        setProvinve(getProvince);
        setUserName(getUserName);
    },[])

    const payment = location.state?.payment || null;

    if (!payment) {
        return (
            <div className={classes.Container} style={{ 
                textAlign: 'center', 
                padding: '2rem', 
                backgroundColor: 'white',
                margin: '2rem',
                borderRadius: '8px'
            }}>
                <h2 style={{ color: '#D92D20', marginBottom: '1rem' }}>Error: No Payment Data</h2>
                <p>No payment information was provided to display the voucher.</p>
                <button 
                    className={classes.btns} 
                    style={{ 
                        marginTop: '1.5rem', 
                        backgroundColor: '#027A48', 
                        color: 'white' 
                    }} 
                    onClick={() => navigate(-1)}
                >
                    <ArrowLeft size={16} style={{ marginRight: '6px' }} />
                    Go Back
                </button>
            </div>
        );
    }

    // --- All API-related state (ledgerData, loading, companyInfo) is removed. ---

    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
    };

    // --- All useEffect hooks (fetchAccounts, fetchCompanyInfo) are removed. ---
    // --- All localStorage logic (getStoredUserName, preparedByName) is removed. ---

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const handleMail = () => alert("Mail clicked!");
    const handlePrinter = () => window.print();
    
    // UPDATED: handleDownload cannot download ledgerData as it's no longer fetched.
    const handleDownload = () => {
        alert("Download function is not available (no API data).");
    };
    const handleSettings = () => navigate("/settings/chart-ledger");

    // helper to format date safely
    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    // helper to format money using existing formatMoney
    const formatCurrency = (value) => {
        return formatMoney(value);
    };

    // --- Derive all values directly from the 'payment' object ---

    const receiptNo = payment?.receipt_number || payment?.invoice_number || payment?.uuid || "N/A";
    const receiptDate = payment?.transaction_date || payment?.date_of_invoice || payment?.created_at || null;
    const receivedFrom = payment?.particular || payment?.supplier?.name || payment?.supplier || "N/A";
    
    // UPDATED: Now correctly reads `payment.mode` string first
    const paymentMethod = payment?.mode?.name || payment?.mode?.name || (payment?.payment_mode
        ? (String(payment.payment_mode) === "1" ? "Bank Transfer" : String(payment.payment_mode) === "2" ? "Cheque" : `Method ${payment.payment_mode}`)
        : "N/A");
    
    const referenceNo = payment?.invoice_number || payment?.uuid || "N/A";

    // UPDATED: Use currency from payment object directly. (Removed baseCurrency state)
    const displayCurrencyCode = payment?.currency?.code || "NGN";
    const displayCurrencySymbol = payment?.currency?.symbol || "₦";

    const lineAmountValue = parseFloat(payment?.total_currency_amount ?? payment?.currency_amount ?? payment?.total_amount ?? payment?.amount ?? 0);
    const subtotalValue = lineAmountValue;
    const taxValue = 0; // No tax info in payment object
    const totalValue = parseFloat(payment?.total_converted_amount ?? payment?.total_currency_amount ?? subtotalValue);

    // This 'Prepared By' name comes directly from the payment object.
    const preparedByName = payment?.user?.name || "N/A";

    // Number-to-words functions (unchanged)
    const integerToWords = (n) => {
        if (n === 0) return "zero";
        const units = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
            "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
            "seventeen", "eighteen", "nineteen"];
        const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
        const scales = [
            { value: 1e12, name: "trillion" },
            { value: 1e9, name: "billion" },
            { value: 1e6, name: "million" },
            { value: 1e3, name: "thousand" },
            { value: 1e2, name: "hundred" }
        ];

        const helper = (num) => {
            let str = "";
            if (num < 20) return units[num];
            if (num < 100) {
                const t = Math.floor(num / 10);
                const u = num % 10;
                return tens[t] + (u ? "-" + units[u] : "");
            }
            for (let i = 0; i < scales.length; i++) {
                const { value, name } = scales[i];
                if (num >= value) {
                    const count = Math.floor(num / value);
                    const remainder = num % value;
                    if (value === 100) {
                        str += helper(count) + " " + name;
                    } else {
                        str += helper(count) + " " + name;
                    }
                    if (remainder) str += " " + helper(remainder);
                    return str;
                }
            }
            return str;
        };
        return helper(n).trim();
    };

    const convertAmountToWords = (amount, currencyCode) => {
        const absAmount = Math.abs(Number(amount) || 0);
        const integerPart = Math.floor(absAmount);
        const fractionPart = Math.round((absAmount - integerPart) * 100);

        const currencyNameMap = {
            NGN: { name: "Naira", fraction: "kobo" },
            USD: { name: "Dollar", fraction: "cents" },
            EUR: { name: "Euro", fraction: "cents" },
            GBP: { name: "Pound", fraction: "pence" }
        };
        const currencyInfo = currencyNameMap[currencyCode] || { name: currencyCode || "Units", fraction: "cents" };

        const intWords = integerToWords(integerPart);
        let words = "";

        if (integerPart === 0 && fractionPart === 0) {
            words = `Zero ${currencyInfo.name}`;
        } else if (fractionPart === 0) {
            words = `${intWords} ${currencyInfo.name}`;
        } else if (integerPart === 0) {
            const fracWords = integerToWords(fractionPart);
            words = `${fracWords} ${currencyInfo.fraction} ${currencyInfo.name.startsWith(currencyCode) ? "" : ""}`.trim();
        } else {
            const fracWords = integerToWords(fractionPart);
            words = `${intWords} ${currencyInfo.name} and ${fracWords} ${currencyInfo.fraction}`;
        }
        return words.replace(/^\w/, c => c.toUpperCase()) + " Only";
    };

    const amountInWords = convertAmountToWords(totalValue, displayCurrencyCode);
    const exportToPDF = async () => {
    const element = printRef.current;
    if (!element) return;

    try {
        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff'
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });

        const imgWidth = 190; // A4 width in mm (minus margins)
        const pageHeight = 277;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        let position = 10;

        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight + 10;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save(`Payment_Voucher_${receiptNo}.pdf`);
    } catch (error) {
        console.error("PDF export failed:", error);
        alert("Failed to generate PDF. Please try again.");
    }
};
const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();

    // Main voucher data
    const voucherData = [
        ["PAYMENT VOUCHER"],
        [""],
        ["Voucher No:", receiptNo, "Date:", formatDate(receiptDate)],
        ["Payee:", receivedFrom, "Payment Mode:", paymentMethod],
        ["Bank Name:", payment?.bank_lodged?.gl_name || "N/A", "Account No:", payment?.bank_lodged?.account_number || "N/A"],
        ["Cheque No:", payment?.teller_number || "N/A", "Cheque Date:", formatDate(payment?.date_logded)],
        [""],
        ["Details of Payment"],
        ["#", "Description / Particulars", `Amount (${displayCurrencyCode})`],
        ["1", payment?.description || "Payment", `${displayCurrencySymbol}${formatCurrency(lineAmountValue)}`],
        ["", "Subtotal", `${displayCurrencySymbol}${formatCurrency(subtotalValue)}`],
        ["", "VAT (7.5%)", `${displayCurrencySymbol}${formatCurrency(taxValue)}`],
        ["", "Total Amount", `${displayCurrencySymbol}${formatCurrency(totalValue)}`],
        [""],
        ["Amount in Words:", amountInWords],
        ["Prepared By:", userName],
        ["Checked By:", payment?.checked_by || "N/A"],
        ["Approved By:", payment?.approved_by || "N/A"],
        ["Narration:", payment?.narration || "N/A"]
    ];

    const ws = XLSX.utils.aoa_to_sheet(voucherData);

    // Auto-size columns
    const colWidths = [
        { wch: 15 }, // A
        { wch: 40 }, // B
        { wch: 20 }, // C
        { wch: 25 }  // D
    ];
    ws['!cols'] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Payment Voucher");

    // Generate and download
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, `Payment_Voucher_${receiptNo}.xlsx`);
};

    return (
        <div>
            <div className={`${classes.noPrint}`}>
                {/* <HeaderNav activePage={pageMap[location.pathname]} /> */}
            </div>

            <div className={classes.Container}>
                {/* Action Buttons (Top Bar) - No Print */}
             
            

                {/* Voucher Title Bar - No Print */}
                <div className={`${classes.matron} ${classes.noPrint}`}> 
                    <div>
                        <button className={classes.backButton}
                            onClick={() => navigate(-1)}> <ArrowLeft size={16} style={{ marginRight: '6px' }}
                            />
                        </button>
                    </div>
                    <div>
                        <p className={classes.toplea}>Payment Receipt</p>
                        <p className={classes.topl}>Payment as of {new Date().toLocaleDateString()}</p>
                    </div>
                </div>

                {/* --- START OF PRINTABLE VOUCHER AREA --- */}
                <div className={classes.containere} ref={printRef}>
                    {/* Voucher Action Icons (Mail, Print) - No Print */}
                    <div className={`${classes.iconbars} ${classes.noPrint}`}>
                        <div className={classes.iconbarss}>
                            <div className={classes.iconbar} onClick={handleMail} style={{ cursor: "pointer" }}>
                                <Mail size={16} />
                            </div>
                            <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                                <Printer size={16} />
                            </div>
                               <img
              onClick={() => exportToExcel()}
              src={ExcelLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToPDF()}
              src={PdfLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
                        </div>
                    </div>

                    {/* UPDATED: Header now uses static placeholders as companyInfo API is removed */}
                    <header className={classes.pr_header}>
                        <div className={classes.pr_logo}>
                            {/* You can set a default logo path here */}
                            <img
                                src={rccgLogo} 
                                alt={"Company Logo"}
                                className={classes.pr_logoImg}
                                // Add fallback in case the image fails
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                        </div>
                        <div className={classes.pr_companyInfo}>
                            {/* Static Placeholder Content */}
                            <h1 className={classes.pr_companyName}>THE REDEEMED CHRISTIAN CHURCH OF GOD</h1>
                            <p className={classes.pr_companyAddr}>{province || ""}</p>
                            <p className={classes.pr_companyContact}>
                               {provinceEmail }
                            </p>
                        </div>
                    </header>
                    
                    <div className={classes.pr_title}> PAYMENT VOUCHER</div>

                    <table className={classes.pr_table}>
                        <tbody>
                            <tr>
                                <th className={classes.pr_label}>Voucher No:</th>
                                <td className={classes.pr_value}>{receiptNo}</td>
                                <th className={classes.pr_label}>Date:</th>
                                <td className={classes.pr_value}>{formatDate(receiptDate)}</td>
                            </tr>
                            <tr>
                                <th className={classes.pr_label}>Payee:</th>
                                <td className={classes.pr_value}>{receivedFrom}</td>
                                <th className={classes.pr_label}>Payment Mode:</th>
                                <td className={classes.pr_value}>{paymentMethod}</td>
                            </tr>
                            <tr>
                                <th className={classes.pr_label}>Bank Name:</th>
                                {/* UPDATED: Uses bank_lodged.gl_name from your object */}
                                <td className={classes.pr_value}>{payment?.bank_lodged?.gl_name || payment?.supplier?.bank_name || payment?.payment_bank || "N/A"}</td>
                                <th className={classes.pr_label}>Account No:</th>
                                {/* UPDATED: Assumes account_number might be on bank_lodged */}
                                <td className={classes.pr_value}>{payment?.bank_lodged?.gl_name || payment?.supplier?.account_number || payment?.account_number || "N/A"}</td>
                            </tr>
                            <tr>
                                <th className={classes.pr_label} >Cheque No:</th>
                                <td className={classes.pr_value}>{payment?.teller_number || payment?.receipt_number || payment?.uuid || "N/A"}</td>
                                <th className={classes.pr_label}>Cheque Date:</th>
                                <td className={classes.pr_value}>{formatDate(payment?.date_logded || payment?.voucher_date || payment?.cheque_date)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className={classes.pr_sectionTitle}>Details of Payment</div>

                    <table className={classes.pr_table}>
                        <thead>
                            <tr>
                                <th className={classes.pr_th}>#</th>
                                <th className={classes.pr_th}>Description / Particulars</th>
                                <th className={classes.pr_th} style={{ textAlign: "right" }}>Amount ({displayCurrencyCode})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={classes.pr_td}>1</td>
                                <td className={classes.pr_td}>{payment?.payment_description || payment?.description || payment?.narration || "Payment"}</td>
                                <td className={classes.pr_td} style={{ textAlign: "right" }}>{displayCurrencySymbol}{formatCurrency(lineAmountValue)}</td>
                            </tr>
                            <tr>
                                <td className={classes.pr_td} colSpan={2} style={{ textAlign: "right", fontWeight: 700 }}>Subtotal</td>
                                <td className={classes.pr_td} style={{ textAlign: "right" }}>{displayCurrencySymbol}{formatCurrency(subtotalValue)}</td>
                            </tr>
                            <tr>
                                <td className={classes.pr_td} colSpan={2} style={{ textAlign: "right", fontWeight: 700 }}>VAT (7.5%)</td>
                                <td className={classes.pr_td} style={{ textAlign: "right" }}>{displayCurrencySymbol}{formatCurrency(taxValue)}</td>
                            </tr>
                            <tr>
                                <td className={classes.pr_td} colSpan={2} style={{ textAlign: "right", fontWeight: 700 }}>Total Amount</td>
                                <td className={classes.pr_td} style={{ textAlign: "right", fontWeight: 800 }}>{displayCurrencySymbol}{formatCurrency(totalValue)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table className={classes.pr_summary}>
                        <tbody>
                            <tr>
                                <td className={`${classes.pr_summaryLabel}`}>Amount in Words:</td>
                                <td className={classes.pr_summaryValue}>{amountInWords || "N/A"}</td>
                            </tr>
                            <tr>
                                <td className={`${classes.pr_summaryLabel}`}>Prepared By:</td>
                                {/* UPDATED: Uses name from payment.user object */}
                                <td className={classes.pr_summaryValue}>{userName}</td>
                            </tr>
                            <tr>
                                <td className={`${classes.pr_summaryLabel}`}>Checked By:</td>
                                <td className={classes.pr_summaryValue}>{payment?.checked_by}</td>
                            </tr>
                            <tr>
                                <td className={`${classes.pr_summaryLabel}`}>Approved By:</td>
                                <td className={classes.pr_summaryValue}>{payment?.approved_by}</td>
                            </tr>
                            <tr>
                                <td className={`${classes.pr_summaryLabel}`}>Narration:</td>
                                <td className={classes.pr_summaryValue}>{payment?.payment_description || payment?.narration || payment?.description}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className={classes.pr_chequeSection}>
                        <h4 className={classes.pr_chequeTitle}>Cheque Details</h4>
                        <table className={classes.pr_table}>
                            <tbody>
                                <tr>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Cheque No</th>
                                    <td className={classes.pr_value}>{payment?.teller_number || payment?.receipt_number || "N/A"}</td>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Bank</th>
                                    {/* UPDATED: Uses bank_lodged.gl_name */}
                                    <td className={classes.pr_value}>{payment?.bank_lodged?.gl_name || payment?.supplier?.bank_name || payment?.payment_bank || "N/A"}</td>
                                </tr>
                                <tr>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Payee</th>
                                    <td className={classes.pr_value}>{receivedFrom}</td>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Amount ({displayCurrencyCode})</th>
                                    <td className={classes.pr_value}>{displayCurrencySymbol}{formatCurrency(totalValue)}</td>
                                </tr>
                                <tr>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Date</th>
                                    <td className={classes.pr_value}>{formatDate(payment?.date_logded || payment?.cheque_date || payment?.transaction_date)}</td>
                                    <th className={classes.pr_label} style={{textAlign: 'right'}}>Signature</th>
                                    <td className={classes.pr_value}>_________________________</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={classes.pr_signatures}>
                        <div className={classes.pr_signBoxprpby}>
                            {/* UPDATED: Uses name from payment.user object */}
                            <div className={classes.dtresp}>{userName}</div>
                            <div className={classes.pr_signBox}>Prepared By</div>
                        </div>
                        
                        <div className={classes.pr_signBox}>Checked By</div>
                        <div className={classes.pr_signBox}>Approved By</div>
                    </div>

                    <div className={classes.pr_footer}>
                        <p className={classes.pr_note}><strong>Note:</strong> Attach the original cheque to this voucher before submission to Accounts for processing.</p>
                        {/* <p className={classes.pr_generated}>Generated by Chequestream Accounting System © {new Date().getFullYear()}</p> */}
                    </div>
                </div>
                {/* --- END OF PRINTABLE VOUCHER AREA --- */}

            </div>
            
        </div>
    );
};

export default PaymentVoucher;
